
      // Detectar y actualizar manifest antes de que se cargue la app
      const path = window.location.pathname;
      const manifestType = path.startsWith('/technician') ? 'technician' : 'admin';
      const manifestLink = document.querySelector('link[rel="manifest"]');
      if (manifestLink) {
        manifestLink.href = `/manifest-${manifestType}.json`;
      }
    